import {FaBicycle, FaBus, FaCar, FaMale, FaMotorcycle, FaPlane, FaShip, FaTruck} from "react-icons/fa";

export const vehicleIcon = {
    BICYCLE: FaBicycle,
    CAR: FaCar,
    STATION_WAGON: FaCar,
    ELECTRICCAR: FaCar,
    WINCH: FaCar,
    QUADRICYCLE: FaCar,
    PICKUPB: FaCar,
    MOTORCYCLE: FaMotorcycle,
    TRUCK: FaTruck,
    BUS: FaBus,
    VAN: FaBus,
    MINIBUS: FaBus,
    UTILITY: FaBus,
    FOOT: FaMale,
    SHIP: FaShip,
    AIRCRAFT: FaPlane,
}